import FontIcon from './FontIcon'
export default FontIcon
